import { TelasIds } from "../../../../../common/utils/tela_ids";
import { IDeleteFuncionarioUseCase } from "../../../presentation/useCases/delete/delete_funcionario_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DeleteFuncionarioUseCase
 */

export class DeleteFuncionarioUseCase implements IDeleteFuncionarioUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async deleteFuncionario(idTela: TelasIds, idFuncionario: number): Promise<void> {
    await this.repository.deleteFuncionario(idTela, idFuncionario);
  }
}